var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("d2-container", [
    _c(
      "div",
      { staticClass: "user-behavior-container" },
      [
        _c(
          "el-row",
          { attrs: { gutter: 20 } },
          [
            _c(
              "el-col",
              { attrs: { span: 6 } },
              [
                _c(
                  "el-card",
                  { staticClass: "info-card", attrs: { shadow: "never" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "clearfix",
                        attrs: { slot: "header" },
                        slot: "header"
                      },
                      [
                        _c("span", { staticClass: "card-title" }, [
                          _vm._v(_vm._s(_vm.$t("userInfo")))
                        ])
                      ]
                    ),
                    _c(
                      "el-collapse",
                      {
                        model: {
                          value: _vm.activeNames,
                          callback: function($$v) {
                            _vm.activeNames = $$v
                          },
                          expression: "activeNames"
                        }
                      },
                      [
                        _c(
                          "el-collapse-item",
                          {
                            attrs: {
                              title: _vm.$t("userBasicIndicators"),
                              name: "1"
                            }
                          },
                          [
                            _c("template", { slot: "title" }, [
                              _c("i", { staticClass: "el-icon-user d2-mr-5" }),
                              _c("b", [
                                _vm._v(_vm._s(_vm.$t("userBasicIndicators")))
                              ])
                            ]),
                            _vm._l(_vm.baseInfo, function(val, key) {
                              return _c(
                                "div",
                                { key: key, staticClass: "info-item" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v(_vm._s(key))
                                  ]),
                                  _c("span", { staticClass: "value" }, [
                                    _vm._v(_vm._s(val))
                                  ])
                                ]
                              )
                            })
                          ],
                          2
                        ),
                        _c(
                          "el-collapse-item",
                          {
                            attrs: {
                              title: _vm.$t("userAttributes"),
                              name: "2"
                            }
                          },
                          [
                            _c("template", { slot: "title" }, [
                              _c("i", {
                                staticClass: "el-icon-s-operation d2-mr-5"
                              }),
                              _c("b", [
                                _vm._v(_vm._s(_vm.$t("userAttributes")))
                              ])
                            ]),
                            _c("div", { staticClass: "info-item" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v(_vm._s(_vm.$t("payCount")))
                              ]),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.payInfo.pay_count || 0))
                              ])
                            ]),
                            _c("div", { staticClass: "info-item" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v(_vm._s(_vm.$t("payTotalAmountCents")))
                              ]),
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.payInfo.pay_amount || 0))
                              ])
                            ])
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-col",
              { staticStyle: { "padding-left": "0" }, attrs: { span: 18 } },
              [
                _c(
                  "el-card",
                  {
                    staticClass: "timeline-card",
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { shadow: "never" }
                  },
                  [
                    _c("div", { staticClass: "filter-header d2-mb-20" }, [
                      _c(
                        "div",
                        { staticClass: "filter-left" },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 4 } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        clearable: "",
                                        filterable: "",
                                        placeholder: ""
                                      },
                                      model: {
                                        value: _vm.paramsData.deduplicate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.paramsData,
                                            "deduplicate",
                                            $$v
                                          )
                                        },
                                        expression: "paramsData.deduplicate"
                                      }
                                    },
                                    _vm._l(_vm.dateList, function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      clearable: false,
                                      "picker-options": _vm.pickerOptionsRadius,
                                      "value-format": "yyyy-MM-dd",
                                      type: "daterange",
                                      align: "right",
                                      "range-separator": _vm.$t("range"),
                                      "start-placeholder": _vm.$t("startDate"),
                                      "end-placeholder": _vm.$t("endDate")
                                    },
                                    model: {
                                      value: _vm.date,
                                      callback: function($$v) {
                                        _vm.date = $$v
                                      },
                                      expression: "date"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 4 } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        clearable: "",
                                        filterable: "",
                                        placeholder: ""
                                      },
                                      model: {
                                        value: _vm.paramsData.dimensionKind,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.paramsData,
                                            "dimensionKind",
                                            $$v
                                          )
                                        },
                                        expression: "paramsData.dimensionKind"
                                      }
                                    },
                                    _vm._l(_vm.deviceList, function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 4 } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t("userIdOrDeviceId"),
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.paramsData.play_id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.paramsData, "play_id", $$v)
                                      },
                                      expression: "paramsData.play_id"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 4 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.getList(1)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("search")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _c(
                  "el-card",
                  { staticClass: "timeline-card", attrs: { shadow: "never" } },
                  [
                    _c("div", { staticClass: "action-bar d2-mb-20" }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.reqLoading,
                            expression: "reqLoading"
                          }
                        ],
                        staticClass: "timeline-content"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "timeline-scroll-container" },
                          [
                            _vm.activitiesGroup.length > 0
                              ? _vm._l(_vm.activitiesGroup, function(group) {
                                  return _c(
                                    "div",
                                    {
                                      key: group.date,
                                      staticClass: "date-group"
                                    },
                                    [
                                      _c(
                                        "h3",
                                        { staticClass: "date-group-title" },
                                        [_vm._v(_vm._s(group.date))]
                                      ),
                                      _c(
                                        "el-timeline",
                                        _vm._l(group.list, function(
                                          item,
                                          index
                                        ) {
                                          return _c(
                                            "el-timeline-item",
                                            {
                                              key: index,
                                              attrs: {
                                                timestamp: item.timestamp,
                                                placement: "top",
                                                color: "#409EFF"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "event-item-card"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "event-content",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          item.expanded = !item.expanded
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "event-main"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "event-name",
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.gotoSearch(
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.content
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-arrow-right icon-right"
                                                      })
                                                    ]
                                                  ),
                                                  item.expanded
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "event-detail-box"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "detail-item"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "detail-label"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Action:"
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "detail-value"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.action ||
                                                                        "--"
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "detail-item"
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "detail-label"
                                                                },
                                                                [_vm._v("Ext:")]
                                                              ),
                                                              _c(
                                                                "pre",
                                                                {
                                                                  staticClass:
                                                                    "detail-value ext-json"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.ext
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                })
                              : _c("el-empty", {
                                  attrs: {
                                    description: _vm.$t("noBehaviorRecord"),
                                    "image-size": 100
                                  }
                                })
                          ],
                          2
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }